import Glide from '@glidejs/glide';
import { Controls } from '@glidejs/glide/dist/glide.modular.esm';

class GuideTaillesV3 {
  constructor() {
    // new Glide('.glide', {
    //   type: 'carousel',
    //   perView: 4,
    // }).mount({ Controls });
    this.glides = document.querySelectorAll('.glide');
    for (var i = 0; i < this.glides.length; i++) {
      var glide = new Glide(this.glides[i], {
        type: 'slider',
        perView: 3,
      });

      glide.mount();
    }
    this.sizeGuide = document.querySelectorAll('.size-guide');
    this.categories = document.querySelectorAll('.category');
    this.products = document.querySelectorAll('.product');
    this.arrows = document.querySelectorAll('.glide__arrows');
    this.tracks = document.querySelectorAll('.glide__track');
    this.productNames = document.querySelectorAll('.product-name');
    this.productContents = document.querySelectorAll('.product-content');
    this.sliderProductNames = document.querySelector('.slider-product-names');
    this.selectedCategoryId = null;
    this.selectedProductId = null;
    if (this.sizeGuide.length > 0) {
      this.sizeGuide.forEach((element) => {
        element.getAttribute('data-size-category-id')
          ? (this.selectedCategoryId = element.getAttribute(
              'data-size-category-id'
            ))
          : null;
        element.getAttribute('data-size-product-id')
          ? (this.selectedProductId = element.getAttribute(
              'data-size-product-id'
            ))
          : null;
      });
      // (this.sizeguide).forEach(sz => {
      // sz.getAttribute('data-category-id') ? this.selectedCategoryId = this.sz.getAttribute('data-category-id') : null;
      // sz.getAttribute('data-product-id') ? this.selectedProductId = this.sz.getAttribute('data-product-id') : null;
      // });
    }
    this.events();
  }
  events() {
    this.initStyles();
    this.addEventListeners();
    document.querySelectorAll('.size-guide-container').forEach((element) => {
      element.classList.remove('invisible');
    });
    // document
    //   .querySelectorAll('.size-guide-container-mobile')
    //   .forEach((element) => {
    //     element.classList.remove('hidden');
    //   });
    // document.querySelectorAll('.size-guide-container');
    this.glides = document.querySelectorAll('.glide');
    for (var i = 0; i < this.glides.length; i++) {
      var glide = new Glide(this.glides[i], {
        type: 'slider',
        perView: 3,
      });

      glide.mount();
    }
    // this.handleScrollableProductNames();
  }

  initStyles() {
    if (this.categories) {
      this.categories.forEach((category, index) => {
        const id = category.getAttribute('data-id')
          ? category.getAttribute('data-id')
          : null;
        if (id === this.selectedCategoryId) {
          category.classList.remove('opacity-30');
          if (category.querySelector('.chevron-down'))
            category.querySelector('.chevron-down').classList.add('hidden');
          if (category.querySelector('.chevron-up'))
            category.querySelector('.chevron-up').classList.remove('hidden');
        } else {
          category.classList.add('opacity-30');
          if (category.querySelector('.chevron-down'))
            category.querySelector('.chevron-down').classList.remove('hidden');
          if (category.querySelector('.chevron-up'))
            category.querySelector('.chevron-up').classList.add('hidden');
        }
        // id === this.selectedCategoryId ? category.classList.remove('opacity-30') : category.classList.add('opacity-30');
        // console.log(category.querySelector('span') ? category.querySelector('span').classList : '');
      });
    }

    if (this.products) {
      this.products.forEach((product) => {
        // const id = product.getAttribute('data-category-id')
        //   ? product.getAttribute('data-category-id')
        //   : null;
        product.classList.add('block');
        product.classList.remove('hidden');
        // id === this.selectedCategoryId
        //   ? product.classList.remove('hidden')
        //   : product.classList.add('block');
      });
    }

    if (this.arrows) {
      this.arrows.forEach((product) => {
        const id = product.getAttribute('data-category-id')
          ? product.getAttribute('data-category-id')
          : null;
        if (id === this.selectedCategoryId) {
          product.classList.remove('hidden');
          //   product.classList.add("flex");
        } else {
          product.classList.add('hidden');
          // product.classList.remove('flex');
        }
      });
    }
    if (this.tracks) {
      this.tracks.forEach((product) => {
        const id = product.getAttribute('data-category-id')
          ? product.getAttribute('data-category-id')
          : null;
        if (id === this.selectedCategoryId) {
          product.classList.remove('hidden');
          //   product.classList.add("flex");
        } else {
          product.classList.add('hidden');
          // product.classList.remove('flex');
        }
        // id === this.selectedCategoryId
        //   ? product.classList.remove("hidden")
        //   : product.classList.add("flex");
        id === this.selectedCategoryId
          ? product.classList.remove('hidden')
          : product.classList.add('block');
      });
    }

    if (this.productNames) {
      this.productNames.forEach((productName) => {
        const id = productName.getAttribute('data-id')
          ? productName.getAttribute('data-id')
          : null;
        if (id === this.selectedProductId) {
          productName.classList.remove('opacity-30');
          if (productName.querySelector('.product-name-chevron-down'))
            productName
              .querySelector('.product-name-chevron-down')
              .classList.add('hidden');
          if (productName.querySelector('.product-name-chevron-up'))
            productName
              .querySelector('.product-name-chevron-up')
              .classList.remove('hidden');
        } else {
          productName.classList.add('opacity-30');
          if (productName.querySelector('.product-name-chevron-down'))
            productName
              .querySelector('.product-name-chevron-down')
              .classList.remove('hidden');
          if (productName.querySelector('.product-name-chevron-up'))
            productName
              .querySelector('.product-name-chevron-up')
              .classList.add('hidden');
        }
      });
    }

    if (this.productContents) {
      this.productContents.forEach((productContent) => {
        const categoryId = productContent.getAttribute('data-category-id')
          ? productContent.getAttribute('data-category-id')
          : null;
        const productId = productContent.getAttribute('data-product-id')
          ? productContent.getAttribute('data-product-id')
          : null;
        productContent.classList.remove('hidden');
        if (
          categoryId === this.selectedCategoryId &&
          productId === this.selectedProductId
        ) {
          productContent.classList.remove('hidden');
          productContent.classList.add('grid');
        } else {
          productContent.classList.add('hidden');
          productContent.classList.remove('grid');
        }
      });
    }
  }

  addEventListeners() {
    if (this.categories && this.sizeGuide) {
      this.categories.forEach((category) => {
        category.addEventListener('click', (e) => {
          e.preventDefault();
          this.categoryClicked(category);
        });
      });
    }

    if (this.productNames && this.sizeGuide) {
      this.productNames.forEach((productName) => {
        productName.addEventListener('click', (e) => {
          e.preventDefault();
          this.productNameClicked(productName);
        });
      });
    }
  }

  categoryClicked(category) {
    const id = this.selectedCategoryId;
    this.selectedCategoryId =
      this.selectedCategoryId === category.getAttribute('data-id')
        ? (this.selectedCategoryId = null)
        : (this.selectedCategoryId = category.getAttribute('data-id'));
    this.selectedProductId = category.getAttribute('data-first-product-id');
    // Prevent null value that make the elements collapse
    if (this.selectedCategoryId === null) this.selectedCategoryId = id;
    this.initStyles();
    this.glides = document.querySelectorAll('.glide');
    for (var i = 0; i < this.glides.length; i++) {
      var glide = new Glide(this.glides[i], {
        type: 'slider',
        perView: 3,
      });

      glide.mount();
    }
  }

  productNameClicked(productName) {
    const id = this.selectedProductId;
    // remove hidden and add flex
    this.selectedCategoryId = productName.getAttribute('data-category-id');
    this.selectedProductId =
      this.selectedProductId === productName.getAttribute('data-id')
        ? null
        : productName.getAttribute('data-id');
    // this.sizeGuide.setAttribute('data-category-id', this.selectedCategoryId);
    // this.sizeGuide.setAttribute('data-product-id', this.selectedProductId);
    // Prevent null value that make the elements collapse
    if (this.selectedProductId === null) this.selectedProductId = id;
    this.initStyles();
  }
}

export default GuideTaillesV3;
